
import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiQuote } = FiIcons;

const SocialProof = () => {
  const testimonials = [
    {
      quote: "Trbe found us three exceptional robotics engineers in just 2 weeks. Their understanding of deep tech talent is unmatched.",
      role: "CTO",
      rating: 5
    },
    {
      quote: "They don't just find candidates – they understand our culture and help us build teams that actually work together.",
      role: "Head of Engineering",
      rating: 5
    },
    {
      quote: "Working with Trbe saved us months of recruiting time. They delivered quality candidates who were the perfect technical and cultural fit.",
      role: "CEO, Robotics Company",
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-brand-purple mb-4"> What Our Clients Say </h2>
          <p className="text-xl text-brand-blue max-w-3xl mx-auto">
            Trusted by the companies building the future of robotics and AI.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="h-5 w-5 text-brand-orange fill-current" />
                  ))}
                </div>
                <SafeIcon icon={FiQuote} className="h-8 w-8 text-brand-lightblue mb-4" />
                <blockquote className="text-gray-700 mb-6 italic">
                  "{testimonial.quote}"
                </blockquote>
              </div>
              <div className="border-t border-gray-100 pt-4">
                <div className="font-semibold text-brand-purple">{testimonial.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
